import React, {Component} from 'react';

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

class NotEnoughTokensPopup extends Popup {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);

        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    componentDidMount() {
        super.componentDidMount();

        this.setState({
            ...super.state,
        });
    }

    componentWillReceiveProps(nextProps) {
        let {currentUser} = nextProps;

        this.setState({disabled: currentUser.isAnonymous()});
    }

    onSubmit(e) {
        e.preventDefault();
        this.close();
        window.open('/membre/wallet/replenish');
    }

    render() {
        let lang = Registry.get('locale');

        let className = 'popup popup-NotEnoughTokensPopup ' + this.state.visibility;


        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <div className="top">
                    <p>{lang.not_enough_jetons_popup_title}</p>
                    <div className="close" onClick={() => this.close()}/>
                </div>
                <div className="content">
                    <div className="text">{lang.not_enough_jetons_popup_message}</div>
                    <button onClick={this.onSubmit}>{lang.not_enough_jetons_popup_button}</button>
                </div>
            </div>
        )
    }
}

NotEnoughTokensPopup.generateKey = function(props) { return 'NotEnoughTokensPopup-popup' };
NotEnoughTokensPopup.mount = function(props, onMount) { return Popup.mount(NotEnoughTokensPopup, props, onMount) };
NotEnoughTokensPopup.open = function(props) {
    var id = NotEnoughTokensPopup.generateKey(props);

    if (!Popup.popups[id]) {
        NotEnoughTokensPopup.mount(props, () => Popup.popups[id].open());
    } else {
        Popup.popups[id].open()
    }
};

export default NotEnoughTokensPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/NotEnoughTokensPopup/index.js